module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/globe-a75c8f41c4f9652ca93636efbdbb43a4.svg";